import { buildQuery } from "../lib/network";
import { coreService } from "../services/coreService";
import { FirstArgumentType } from "../types/ArgumentTypes";

export const postAuthOTPSend = (headers: any) => (body: FirstArgumentType<typeof coreService.authOtpSendCreate>) => {
  return buildQuery(coreService.authOtpSendCreate(body, { headers }), (response) => {
    return response.data;
  });
};

export const postAuthAnonymousTokenIssueViaOtp =
  (headers: any) => (body: FirstArgumentType<typeof coreService.authAnonymousTokenIssueViaOtpNotifyCreate>) => {
    return buildQuery(coreService.authAnonymousTokenIssueViaOtpNotifyCreate(body, { headers }), (response) => {
      return response.data;
    });
  };

export type OTPVerifyError = Awaited<ReturnType<typeof coreService.authOtpVerifyEmailCreate>>["error"];
export type OTPErrorCode = NonNullable<Extract<OTPVerifyError, { errorCode?: any }>["errorCode"]>;
export const OTPErrorMessage: Record<OTPErrorCode, string> = {
  MAX_ATTEMPTS_REACHED: "Maximum attempts reached",
  EXPIRED: "One-time password is expired",
  NOT_FOUND: "One-time password is expired",
  WRONG: "One-time password is incorrect",
};
export const postAuthVerifyEmail =
  (headers: any) => (body: FirstArgumentType<typeof coreService.authOtpVerifyEmailCreate>) => {
    return buildQuery(
      coreService.authOtpVerifyEmailCreate(body, { headers }),
      (response) => {
        return response.data;
      },
      true,
      {
        onUnauthorized: undefined, // No need to kick out user on email verification
      },
    );
  };

export const putAuthOTPUpdatePhone =
  (headers: any) => (body: FirstArgumentType<typeof coreService.authOtpUpdatePhoneUpdate>) => {
    return buildQuery(coreService.authOtpUpdatePhoneUpdate(body, { headers }), (response) => {
      return response.data;
    });
  };

export const putAuthOTPUpdateEmail =
  (headers: any) => (body: FirstArgumentType<typeof coreService.authOtpUpdateEmailUpdate>) => {
    return buildQuery(coreService.authOtpUpdateEmailUpdate(body, { headers }), (response) => {
      return response.data;
    });
  };
